function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import PropTypes from 'prop-types';
import React, { createContext, useContext } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { getAttributeForBrand, getPossibleBrandAttributeValues } from "../../constants";
import { domElPropTypeValidator } from "../../utils";
export var BrandContext = /*#__PURE__*/createContext(null);
export function useBrand() {
  return useContext(BrandContext);
}
var injectFonts = function injectFonts(theme) {
  if (!theme.assets || !theme.assets.fonts || typeof document === 'undefined') {
    return;
  }
  var id = "csl-font-faces-".concat(theme.brand);

  // prevent the same fonts being injected twice
  if (document.getElementById(id)) return;
  var fontFaces = theme.assets.fonts;
  var styleTag = document.createElement('style');
  styleTag.id = id;
  styleTag.textContent = fontFaces;
  document.head.appendChild(styleTag);
};

/**
 * Documentation:
 * 
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/setup/developers)
 **/
var BrandProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(BrandProvider, _React$Component);
  var _super = _createSuper(BrandProvider);
  function BrandProvider(props) {
    var _this;
    _classCallCheck(this, BrandProvider);
    _this = _super.call(this, props);
    _this.GlobalStyle = void 0;
    _this.portalEl = void 0;
    var fonts = _this.props.theme && _this.props.theme.assets && _this.props.theme.assets.fonts;

    /** TODO: find a home for this */
    _this.GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      html, body {\n        margin: 0;\n        padding: 0;\n      }\n      \n      main {\n        display: block; /* IE 11 */\n      }\n\n      .csl-dialog-open {\n        overflow: hidden;\n      }\n\n      .csl-sr-only {\n        position: absolute;\n        width: 1px;\n        height: 1px;\n        margin: -1px;\n        padding: 0;\n        overflow: hidden;\n        clip: rect(0, 0, 0, 0);\n        border: 0;\n      }\n\n      ", "\n    "])), _this.props.ssr && fonts);
    if (!_this.props.ssr) injectFonts(_this.props.theme);
    return _this;
  }
  _createClass(BrandProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props, _this$props$theme, _this$props2, _this$props2$theme;
      if (typeof document !== 'undefined' && !this.portalEl) {
        this.portalEl = document.createElement('div');
        document.body.appendChild(this.portalEl);
      }
      return {
        brand: (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$theme = _this$props.theme) === null || _this$props$theme === void 0 ? void 0 : _this$props$theme.brand,
        brandTitle: getAttributeForBrand((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$theme = _this$props2.theme) === null || _this$props2$theme === void 0 ? void 0 : _this$props2$theme.brand, 'TITLE'),
        portalEl: this.portalEl
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$theme, _this$props3, _this$props3$theme;
      if (((_prevProps$theme = prevProps.theme) === null || _prevProps$theme === void 0 ? void 0 : _prevProps$theme.brand) !== ((_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$theme = _this$props3.theme) === null || _this$props3$theme === void 0 ? void 0 : _this$props3$theme.brand)) {
        injectFonts(this.props.theme);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.portalEl) {
        document.body.removeChild(this.portalEl);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        cssPrefix = _this$props4.cssPrefix,
        theme = _this$props4.theme;
      return /*#__PURE__*/React.createElement(BrandContext.Provider, {
        value: this.getChildContext()
      }, /*#__PURE__*/React.createElement(this.GlobalStyle, null), /*#__PURE__*/React.createElement(ThemeProvider, {
        theme: _objectSpread(_objectSpread({}, theme), {}, {
          cssPrefix: cssPrefix
        })
      }, React.Children.toArray(this.props.children)));
    }
  }]);
  return BrandProvider;
}(React.Component);
BrandProvider.displayName = 'BrandProvider';
BrandProvider.defaultProps = {
  cssPrefix: '&&&',
  ssr: false,
  theme: {}
};
BrandProvider.childContextTypes = {
  brand: PropTypes.string,
  brandTitle: PropTypes.oneOf(getPossibleBrandAttributeValues('TITLE')),
  portalEl: domElPropTypeValidator
};
export default BrandProvider;